// ============================================================================
// frontend/src/constants/themes.ts
// ============================================================================

export interface ThemePreset {
    id: string;
    name: string;
    description: string;
    icon: string;
    colors: {
      primary: string;
      secondary: string;
      accent: string;
      destructive: string;
      dark_primary: string;
      dark_background: string;
      dark_foreground: string;
      dark_card: string;
      dark_secondary: string;
      dark_accent: string;
    };
    font: string;
    borderRadius: string;
  }
  
  export const THEME_PRESETS: ThemePreset[] = [
    {
      id: 'smartlawyer',
      name: 'SmartLawyer Classic',
      description: 'Le thème par défaut de SmartLawyer',
      icon: '⚖️',
      colors: {
        primary: '#E01E5A',
        secondary: '#F0F4F8',
        accent: '#F5F5F5',
        destructive: '#EF4444',
        dark_primary: '#E01E5A',
        dark_background: '#212121',
        dark_foreground: '#EDEDED',
        dark_card: '#2E2E2E',
        dark_secondary: '#313131',
        dark_accent: '#424242'
      },
      font: "'Inter', sans-serif",
      borderRadius: '0.75'
    },
    {
      id: 'professional_blue',
      name: 'Professionnel Bleu',
      description: 'Élégant et corporate',
      icon: '💼',
      colors: {
        primary: '#2563EB',
        secondary: '#F1F5F9',
        accent: '#E0E7FF',
        destructive: '#DC2626',
        dark_primary: '#3B82F6',
        dark_background: '#0F172A',
        dark_foreground: '#F8FAFC',
        dark_card: '#1E293B',
        dark_secondary: '#334155',
        dark_accent: '#475569'
      },
      font: "'Inter', sans-serif",
      borderRadius: '0.5'
    },
    {
      id: 'legal_green',
      name: 'Juridique Vert',
      description: 'Sobre et professionnel',
      icon: '📚',
      colors: {
        primary: '#059669',
        secondary: '#F0FDF4',
        accent: '#D1FAE5',
        destructive: '#DC2626',
        dark_primary: '#10B981',
        dark_background: '#022C22',
        dark_foreground: '#F0FDF4',
        dark_card: '#064E3B',
        dark_secondary: '#065F46',
        dark_accent: '#047857'
      },
      font: "'Lato', sans-serif",
      borderRadius: '0.5'
    },
    {
      id: 'modern_purple',
      name: 'Moderne Violet',
      description: 'Créatif et innovant',
      icon: '🎨',
      colors: {
        primary: '#7C3AED',
        secondary: '#FAF5FF',
        accent: '#EDE9FE',
        destructive: '#DC2626',
        dark_primary: '#8B5CF6',
        dark_background: '#1E1B4B',
        dark_foreground: '#F5F3FF',
        dark_card: '#312E81',
        dark_secondary: '#3730A3',
        dark_accent: '#4338CA'
      },
      font: "'Poppins', sans-serif",
      borderRadius: '1'
    },
    {
      id: 'minimal_slate',
      name: 'Minimaliste Ardoise',
      description: 'Épuré et moderne',
      icon: '⚪',
      colors: {
        primary: '#64748B',
        secondary: '#F8FAFC',
        accent: '#E2E8F0',
        destructive: '#DC2626',
        dark_primary: '#94A3B8',
        dark_background: '#0F172A',
        dark_foreground: '#F1F5F9',
        dark_card: '#1E293B',
        dark_secondary: '#334155',
        dark_accent: '#475569'
      },
      font: "'Inter', sans-serif",
      borderRadius: '0.25'
    },
    {
      id: 'warm_orange',
      name: 'Chaleureux Orange',
      description: 'Dynamique et accueillant',
      icon: '🔥',
      colors: {
        primary: '#F97316',
        secondary: '#FFF7ED',
        accent: '#FFEDD5',
        destructive: '#DC2626',
        dark_primary: '#FB923C',
        dark_background: '#431407',
        dark_foreground: '#FFF7ED',
        dark_card: '#7C2D12',
        dark_secondary: '#9A3412',
        dark_accent: '#C2410C'
      },
      font: "'Open Sans', sans-serif",
      borderRadius: '0.75'
    },
    {
      id: 'luxury_gold',
      name: 'Luxe Or',
      description: 'Prestigieux et raffiné',
      icon: '👑',
      colors: {
        primary: '#D97706',
        secondary: '#FFFBEB',
        accent: '#FEF3C7',
        destructive: '#DC2626',
        dark_primary: '#F59E0B',
        dark_background: '#451A03',
        dark_foreground: '#FFFBEB',
        dark_card: '#78350F',
        dark_secondary: '#92400E',
        dark_accent: '#B45309'
      },
      font: "'Playfair Display', serif",
      borderRadius: '0.5'
    },
    {
      id: 'fresh_teal',
      name: 'Frais Turquoise',
      description: 'Moderne et apaisant',
      icon: '🌊',
      colors: {
        primary: '#14B8A6',
        secondary: '#F0FDFA',
        accent: '#CCFBF1',
        destructive: '#DC2626',
        dark_primary: '#2DD4BF',
        dark_background: '#042F2E',
        dark_foreground: '#F0FDFA',
        dark_card: '#134E4A',
        dark_secondary: '#115E59',
        dark_accent: '#0F766E'
      },
      font: "'Inter', sans-serif",
      borderRadius: '0.75'
    },
    {
      id: 'corporate_navy',
      name: 'Corporate Marine',
      description: 'Sérieux et traditionnel',
      icon: '🏛️',
      colors: {
        primary: '#1E40AF',
        secondary: '#EFF6FF',
        accent: '#DBEAFE',
        destructive: '#DC2626',
        dark_primary: '#3B82F6',
        dark_background: '#0C1E3D',
        dark_foreground: '#EFF6FF',
        dark_card: '#1E3A8A',
        dark_secondary: '#1E40AF',
        dark_accent: '#2563EB'
      },
      font: "'Roboto', sans-serif",
      borderRadius: '0.5'
    },
    {
      id: 'modern_pink',
      name: 'Moderne Rose',
      description: 'Moderne et dynamique',
      icon: '💗',
      colors: {
        primary: '#EC4899',
        secondary: '#FDF2F8',
        accent: '#FCE7F3',
        destructive: '#DC2626',
        dark_primary: '#F472B6',
        dark_background: '#500724',
        dark_foreground: '#FDF2F8',
        dark_card: '#831843',
        dark_secondary: '#9F1239',
        dark_accent: '#BE123C'
      },
      font: "'Poppins', sans-serif",
      borderRadius: '1'
    }
  ];
  
  export const FONT_PRESETS = [
    { name: 'Inter (Défaut)', value: "'Inter', sans-serif" },
    { name: 'Roboto', value: "'Roboto', sans-serif" },
    { name: 'Open Sans', value: "'Open Sans', sans-serif" },
    { name: 'Lato', value: "'Lato', sans-serif" },
    { name: 'Poppins', value: "'Poppins', sans-serif" }
  ];
  